import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Vendors
import languageUtils from "../../language/language.utils";
import apiClientConstants from "../../../constants/api-client";
import usd from "../../usd/usd";
import keycloakUtils from "../../keycloak/keycloak.utils";
import sessionUtils from "../../session/session.utils";
// Constants
import constants from "./constants/api.configurations.constants";
import storageConstants from "../../../constants/storage";
// Utils
import { getAccessToken } from "./utils/api.configurations.utils";
// Types

var addTokenHeader = function addTokenHeader(channel) {
  return getAccessToken(channel) ? _defineProperty({}, storageConstants.COOKIES_IDS.ACCESS_TOKEN, getAccessToken(channel)) : {};
};
var getInitHeaders = function getInitHeaders(_ref2) {
  var channel = _ref2.channel,
    customHeaders = _ref2.customHeaders,
    _ref2$language = _ref2.language,
    lang = _ref2$language === void 0 ? languageUtils.getUILocale() : _ref2$language;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, constants.HEADERS), customHeaders), addTokenHeader(channel)), {}, _defineProperty(_defineProperty({}, constants.ACCEPT_LANGUAGE_HEADER, lang), constants.APPLICATION_LOCALE, lang));
};
var doRefreshTokenAction = function doRefreshTokenAction(channel) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, apiClientConstants.CHANNELS.CC, function () {
    return usd.core().getAgentAccessToken();
  }), apiClientConstants.CHANNELS.OPS, function () {
    return keycloakUtils.refreshKeycloakToken({
      onError: keycloakUtils.doKeycloakLogout
    });
  }), apiClientConstants.CHANNELS.WEB, function () {
    return sessionUtils.refreshToken();
  }), apiClientConstants.CHANNELS.GIL, function () {
    return sessionUtils.refreshToken({
      isGil: true
    });
  })[channel];
};
var makeLogout = function makeLogout(channel) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, apiClientConstants.CHANNELS.CC, function () {
    return usd.core().onInvalidSession();
  }), apiClientConstants.CHANNELS.OPS, function () {
    return keycloakUtils.doKeycloakLogout();
  }), apiClientConstants.CHANNELS.WEB, function () {
    return sessionUtils.logout();
  }), apiClientConstants.CHANNELS.GIL, function () {
    return sessionUtils.logout();
  })[channel];
};
export { doRefreshTokenAction, getInitHeaders, makeLogout };